const routes = [
  // 课程管理
  {
    // 课程管理列表
    path: "/courseManage",
    name: "courseManage",
    meta: {
      title: "课程管理",
      volcengine: true
    },
    component: () => import("@/pages/lsForeign/courseManage/index.vue")
  },
  {
    // 添加/编辑外教
    path: "/courseEditor",
    name: "courseEditor",
    meta: {
      title: "添加课程",
      volcengine: true
    },
    component: () => import("@/pages/lsForeign/courseManage/editor.vue")
  },
];
export default routes;
